import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import BaseButton from 'components/Buttons/Button';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

export const Header = styled.h1`
  color: ${ColorPalette.HEX.OutrageousOrange};
  font-size: 20px;
  line-height: 28px;
  font-weight: 600;
  margin-bottom: 24px;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-self: flex-end;
  flex-wrap: wrap;

  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  margin: 0;
  background: ${ColorPalette.HEX.White};
  padding: 16px 16px 24px 16px;
  margin-top: 32px;
`;

export const SendButton = styled(BaseButton)`
  height: 56px;
  font-size: 16px;
  width: 100%;
`;
